import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Button } from '@mui/material'
import type { CSSProperties } from 'react'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'

interface YisBackButtonProps {
  onClick: () => void
  className?: string
  style?: CSSProperties
}

function YisBackButton (props: YisBackButtonProps) {
  const { t } = useTranslation()
  const { className, onClick, style } = props
  const title = t('Back')

  return <Button className={`back-btn ${className}`} style={style} onClick={onClick} title={title}>
    <ArrowBackIcon />
  </Button>
}

export default memo(YisBackButton)
